import { default as enCommon } from "locales/en/common.json";
import { default as bgCommon } from "locales/bg/common.json";

export const EN = "en";
export const BG = "bg";

// First one is default
export const LOCALES = [EN, BG];

export const LANGUAGES = {
  [EN]: {
    name: EN,
    files: {
      translation: { ...enCommon.translation /* add other files here*/ },
    },
  },
  [BG]: {
    name: BG,
    files: {
      translation: { ...bgCommon.translation /* add other files here*/ },
    },
  },
};
